export default __webpack_public_path__ + "static/media/atoms-logo-original.27c4c3b5.svg";